import ricoPic from "@/public/images/artists/rico.png";
import { Artist } from "@/types/types";

export const rico = {
  id: "225",
  name: "Rico",
  image: ricoPic,
  description: `Rico's voice has a distinct, resonant tone and brings a raw, conversational energy, seamlessly flowing from thought-provoking lines to fiery, assertive bars.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Frico-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Unprocessed", "Spoken Word"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 47,
        high: 65,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
